import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAllPage,getPatientId } from "../../../serviecs/patient.serviec";
import { setMessage } from "../message/index";
export const getList = createAsyncThunk(
  "patient/getList",
  async (request, thunkAPI) => {
    const { page } = request;
    try {
      const { content, totalElements, totalPages } = await getAllPage(request);
      return {
        records: content,
        totalElements: totalElements,
        totalPages: totalPages,
        page: page,
      };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);
export const getPatientById = createAsyncThunk(
  "patient/getUserById",
  async (request, thunkAPI) => {
    try {
      const data = await getPatientId (request);
      return {
        record: data,
      };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);
export const medicalHistories = [
  { value: "LONG_BLEEDING", lable: "Chảy máu lâu" },
  { value: "DIABETES", lable: "Tiểu đường" },
  { value: "DRUG_ALLERGY", lable: "Dị ứng thuốc" },
  { value: "INFECTIOUS_DISEASES", lable: "Truyền nhiễm" },
  { value: "HIGH_BLOOD_PRESSURE", lable: "Huyết áp cao" },
  { value: "LOW_BLOOD_PRESSURE", lable: "Huyết áp thấp" },
  { value: "MATERNITY", lable: "Thai sản" },
  { value: "RHEUMATISM", lable: "Thấp khớp" },
  { value: "HEART_DISEASE", lable: "Tim" },
  { value: "STOMACH_DISEASES", lable: "Dạ dày" },
  { value: "LIVER_DISEASES", lable: "Gan" },
  { value: "LUNG_DISEASES", lable: "Phổi" },
  { value: "NORMAL", lable: "Bình thường" },
];
